module.exports = __webpack_public_path__ + "static/media/telltale_brain.82b68a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/telltale_brain.jpg
// module id = 122
// module chunks = 0